<template>
  <div class="container">
    <el-form ref="form" :model="searchFormData" :inline="true">

      <el-form-item label="需求状态">
        <!--0 待审核 1 招聘中 2 招聘完成 3 下架 4 驳回-->
        <el-select v-model="searchFormData.status" 
        placeholder="请选择"    
        clearable
         filterable
         >
          <el-option label="待审核" value="0"></el-option>
          <el-option label="招聘中" value="1"></el-option>
          <el-option label="招聘完成" value="2"></el-option>
          <el-option label="下架" value="3"></el-option>
          <el-option label="驳回" value="4"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择项目">
        <el-select
                v-model="searchFormData.project_id"
                clearable
                filterable
                placeholder="全部"
                style="width:100%"
              >
              <el-option
                v-for="item in projectList"
                :key="item.project_id"
                :label="item.name"
                :value="item.project_id"
              />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="search()">查询</el-button>
      </el-form-item>
      <el-form-item style="float:right">
        <el-button type="primary" @click="handleAdd()">发布招聘需求</el-button>
      </el-form-item>
    </el-form>


    <div class="table">
        <!-- start -->
        <div class="pro_unit" v-for="(item, index) in pageProps.records" :key="index">
          <div class="pro_a">
            <img :src="item.logo" />
          </div>
          <div class="pro_b">
            <div>
              <b>{{ item.title }}</b> <span>{{item.created_at}}</span>
            </div>
            <p> 
              <span>{{item.company_name}}</span>
              {{ item.education_str }}
              {{ item.method_str }}
            </p>
          </div>
          <div class="pro_c">
            <b>{{ item.views }}</b>
            <p>浏览量</p>
          </div>
          <div class="pro_c">
            <b>{{ item.interact }}</b>
            <p>已沟通</p>
          </div>

          <div class="pro_c">
            <b>{{ item.status_str }}</b>
          </div>

          <div class="pro_d">
            <el-button plain @click.native="edit(item)">修改</el-button>
          </div>
          <div class="pro_e">
            <el-dropdown>
              <span class="el-dropdown-link">
                更多操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-edit" style="color:#4C71DB" @click.native="cancel(item)">下架职位</el-dropdown-item>
                <el-dropdown-item icon="el-icon-delete" style="color:#FF4444" @click.native="del(item)">删除职位</el-dropdown-item>
                <el-dropdown-item icon="el-icon-edit" style="color:#4C71DB" @click.native="preview(item)">预览职位</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      <!-- end -->
      </div>
    <!--分页-->
    <div class="page_box">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
       :total="pageProps.total" 
       :page-size="pageProps.pageSize" 
       :page-sizes="[5, 10, 50, 100]"
       :current-page="pageProps.pageNum" 
       @size-change="handleSizeChange" 
       :hide-on-single-page="true"	
       @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { jobList,addJob,updateJob,changeStatus} from "@/api/director/job/index.js";
import { projectList} from "@/api/director/project/index";


export default {
  data () {
    return {
      searchLoading: false,
      pageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 5,
      },
      projectList:[],

      searchFormData: {
        project_id	: "",
        status: "",//状态0 未审核 1 已审核 2 已拒绝
        page: "",
        limit: ""
      }
    };
  },
  mounted () {
    this.initProjectList();
    this.fetchData();
  },

  methods: {
    
    handleAdd () {
      // 打开页面
      const routeData = this.$router.resolve({
        name: 'director-demand-publish'
      })
      window.open(routeData.href, '_blank')
    },

    search(){
      this.fetchData();
    },
    
    fetchData () {
      var that = this;
      that.searchFormData.page = that.pageProps.pageNum;
      that.searchFormData.limit = that.pageProps.pageSize;

      jobList(that.searchFormData).then((response) => {
        console.log(response);
        that.pageProps.records = response.data.data;
        that.pageProps.total = response.data.total;
      });
    },

    initProjectList(){
      var that = this;
      projectList({}).then((response) => {
        console.log('projectList',response);
        that.projectList = response.data;
      });
    },

    // 当前页变更
    handleCurrentChange (num) {
      this.pageProps.pageNum = num;
      this.fetchData();
    },

    // 每页显示页面数变更
    handleSizeChange (size) {
      this.pageProps.pageSize = size;
      this.fetchData();
    },


    edit(item){
      console.log(item);
     /* this.$router.push({ 
        name: 'director-demand-publish',
        query:{job_id:item.job_id} 
     });*/


     const routeData = this.$router.resolve({
        name: 'director-demand-publish',
        query:{job_id:item.job_id} 
      })
      window.open(routeData.href, '_blank')

    },

    preview(item){
      console.log(item);
      this.$router.push({ 
        name: 'job-detail',
        query:{id:item.job_id} 
     });
    },

    

    del(item){
      var that=this;
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
            const job_id	=item.job_id;
            changeStatus({job_id:job_id,status:4}).then((response) => {
              console.log(response);
              if(response.code==200){
                  that.fetchData();
              }else{
                          that.$message.error(response.msg?response.msg:"操作失败");

              }
            });
          
        }).catch(() => {
        
        });
    },

    cancel(item){
      var that=this;
        this.$confirm('确定下架?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
            const job_id	=item.job_id;
            changeStatus({job_id:job_id,status:3}).then((response) => {
              console.log(response);
              if(response.code==200){
                  that.fetchData();
              }else{
                          that.$message.error(response.msg?response.msg:"操作失败");

              }
            });
          
        }).catch(() => {
        
        });
    },


  },


};
</script>

<style lang="scss" scoped>

.table {
  min-height: 500px;
}
.pro_unit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fafafa;
  border: 1px solid #cccccc;
  border-radius: 6px;
  margin-bottom: 24px;
  padding: 20px;
  height: 64px;
  font-size: 14px;
  color: #999;
  .pro_a {
    img {
      width: 64px;
      height: 64px;
      object-fit: cover;
      border-radius: 3px;
    }
  }
  .pro_b {
    max-width: 480px;
    min-width: 300px;
    height: 64px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    div {
      b {
        font-size: 20px;
        margin-right: 50px;
        color: #333;
      }
      span {
        font-size: 12px;
        color: #999999;
      }
    }
    p {
      white-space: nowrap;
      word-break: keep-all;
      overflow: hidden;
      text-overflow: ellipsis;

      span{
        color: #4C71DB;
      }
    }
  }
  .pro_c {
    width: 130px;
    text-align: center;
    b {
      color: #333;
      line-height: 30px;
    }
  }
  .pro_d {
    display: flex;
    justify-content: center;
    width: 120px;
  }
}
.page_box {
  display: flex;
  justify-content: center;
}
</style>